import { Component, ElementRef, EventEmitter, Output, ViewChild, input } from '@angular/core';

@Component({
  selector: 'vectronic-image-input',
  imports: [],
  template: `
    <div class="image-upload-container">
      <input
        #fileInput
        id="fileInput"
        type="file"
        multiple
        (change)="onFilesSelected($event)"
        accept="image/*"
        [disabled]="disabled()"
        hidden
      />
      <div class="preview-container">
        @for (file of imagePreviews; track file; let i = $index) {
          <div class="image-preview">
            <img [src]="file" class="preview" />
            @if (!disabled()) {
              <button class="delete-btn" (click)="removeImage(i)">✖</button>
            }
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .image-upload-container {
        /* Optional: Add padding or margin if needed */
      }
      .preview-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-start;
      }
      .image-preview {
        position: relative;
      }
      .preview {
        width: 80px;
        height: 80px;
        border-radius: 5px;
        object-fit: cover;
      }
      .delete-btn {
        position: absolute;
        top: -5px;
        right: -5px;
        background: red;
        color: white;
        border: none;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    `,
  ],
})
export class ImageInputComponent {
  disabled = input(false);
  imagePreviews: string[] = [];
  selectedFiles: File[] = [];

  @Output() imagesSelected = new EventEmitter<File[]>();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const newFiles = Array.from(input.files);
      this.selectedFiles.push(...newFiles);
      this.imagesSelected.emit(this.selectedFiles);

      newFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviews.push(reader.result as string);
        };
        reader.readAsDataURL(file);
      });
    }
  }

  removeImage(index: number) {
    this.selectedFiles.splice(index, 1);
    this.imagePreviews.splice(index, 1);
    this.imagesSelected.emit(this.selectedFiles);
  }

  triggerFileInput() {
    if (this.disabled()) return;
    this.fileInput.nativeElement.click();
  }
}
